import React from "react";
import "./Home.css";

const WhyChoose = () => {
  const points = [
    "We partner with businesses to understand their goals and deliver solutions that support long-term growth and success.",
    "Our expertise combines strategy, creativity, technology, and business intelligence to create impactful digital experiences.",
    "Every solution is designed to be scalable, reliable, and future-ready, helping businesses adapt and grow with confidence.",
    "We build lasting relationships by solving real business challenges and delivering value that extends beyond project completion.",
  ];

  

  return (
    <section className="backdiv">

      <h2 className="main-title">
        Why Businesses Choose Vedastra
      </h2>

      <div className="whychoose-grid">
        <div>
 <div className="why_img_div">
          <img src="wedo.webp" className="cover-img" loading="lazy" alt="vedastra"/>
        </div>
        </div>
        <div className="whychoose-section">
          
            <div>
        {points.map((point, index) => (
          <div className="whychoose-card" key={index}>
            <span className="why-icon">⚡</span>
            <p className="main-text-white">{point}</p>
          </div>
        ))}
        </div>
        </div>
      </div>
 {/* <img src="back-bg.png" className="bg-bottom-img" alt="decor" /> */}
    </section>
  );
};

export default WhyChoose;